module.exports = __webpack_public_path__ + "img/icon-store-outline.d58be42d.svg";